module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signup-2a622118b9a0410f671743ea9773e16c.jpg";